import { useRouterStore } from '../router-store/index.tsx';
import type { RouterActionsType, RouterState } from '../router-store/types.tsx';

/**
 * @deprecated
 * Do not use this hook, as it creates performance problems during transitions. Use
 * useIsActiveRoute or subscribers instead.
 *
 * Utility hook for accessing the public router store
 *
 * Note that this should eventually filter out private state / actions
 */
export const useRouter: () => [RouterState, RouterActionsType] = () => useRouterStore();
